var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'r-checkbox': true,
    'r-checkbox--disabled': this.disabled
  }},[_c('input',_vm._g({class:{
      'r-checkbox--input': true,
      'r-checkbox--disabled': this.disabled
    },attrs:{"type":"checkbox","id":`input-${_vm._uid}`,"disabled":_vm.disabled},domProps:{"checked":_vm.value}},_vm.listeners)),(_vm.loading)?_c('r-spinner',{staticClass:"r-checkbox--loading",attrs:{"color":"rgb(36, 105, 235)","size":"14px"}}):_c('label',{class:{
      'r-checkbox--label': true,
      'r-checkbox--rounded': this.rounded,
      'r-checkbox--disabled': this.disabled
    },attrs:{"for":`input-${_vm._uid}`}}),_c('label',{class:{
      'r-checkbox--text': _vm.$slots.default,
      'r-checkbox--disabled': this.disabled
    }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }